import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import Footer from '../components/Common/Footer';
import '../styles/Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [mobileRelease, setMobileRelease] = useState(null);

  const { login } = useAuth();
  const navigate = useNavigate();

  // Dernière version de l'application Android publiée (bouton de téléchargement)
  useEffect(() => {
    api.get('/mobile/app-version')
      .then(({ data }) => { if (data?.apk_url) setMobileRelease(data); })
      .catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(username, password);

    if (result.success) {
      navigate('/');
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <div className="login-split">
      {/* Volet gauche : présentation */}
      <aside className="login-showcase">
        <div className="showcase-brand">
          <span className="brand-mark">A</span>
          <span className="brand-name">ARA &amp; ESSIE-EHOUN</span>
        </div>

        <div className="showcase-body">
          <h1>Gérez vos associations en toute simplicité.</h1>
          <p className="showcase-lead">
            Membres, adhérents, cotisations, prestations et communication par SMS,
            réunis dans un seul espace sécurisé.
          </p>

          <div className="showcase-modules">
            <div className="showcase-module">
              <span className="module-tag">ARA</span>
              <p>Membres, cotisations, prestations et dépenses</p>
            </div>
            <div className="showcase-module">
              <span className="module-tag">ESSIE-EHOUN</span>
              <p>Adhérents, cotisations, décès et envoi de SMS</p>
            </div>
          </div>

          {mobileRelease && (
            <a className="app-download" href={mobileRelease.apk_url} download>
              <span className="app-download-icon" aria-hidden="true">⬇</span>
              <span>
                <strong>Application Android pour les membres</strong>
                <small>Télécharger l'APK · version {mobileRelease.version}</small>
              </span>
            </a>
          )}
        </div>

        <p className="showcase-footer">© {new Date().getFullYear()} ARA &amp; ESSIE-EHOUN</p>
      </aside>

      {/* Volet droit : formulaire */}
      <main className="login-panel">
        <div className="login-box">
          <div className="login-mobile-brand">
            <span className="brand-mark">A</span>
            <span>ARA &amp; ESSIE-EHOUN</span>
          </div>

          <h2>Connexion</h2>
          <p className="login-subtitle">Entrez vos identifiants pour accéder à votre espace.</p>

          {error && <div className="error-message">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="username">Nom d'utilisateur</label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
                autoFocus
                required
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Mot de passe</label>
              <div className="password-field">
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                  required
                  disabled={loading}
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
                >
                  {showPassword ? 'Masquer' : 'Afficher'}
                </button>
              </div>
            </div>

            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'Connexion...' : 'Se connecter'}
            </button>
          </form>

          <Footer className="login-footer" />
        </div>
      </main>
    </div>
  );
};

export default Login;
